import { IDataSource, IQuery, IStep } from "@types";
import { generateInitialQuery, getSelectedStepDetailsById, isDataSource, isSourceAvailableInQuery } from "@utils";
import { hasValue } from "uxp/components";

export function updateStep(query: IQuery, selectedStepId: string, field: string, value: any) {
    return updateFieldValue(query, selectedStepId, field, value)
}

export function updateSource(query: IQuery, selectedStepId: string, field: string, source: IDataSource | IStep) {
    if (!hasValue(field) || !source) return
    const _query = updateFieldValue(query, selectedStepId, field, source.id)
    if (isDataSource(source)) {
        if (!isSourceAvailableInQuery(_query, source.id)) {
            _query.sources.push(source)
        }
        else {
            // replace params 
            for (const s of _query.sources) {
                if (s.id == source?.id) s.params = { ...source?.params || [] }
            }
        }
    }
    return _query
}

function updateFieldValue(query: IQuery, selectedStepId: string, field: string, value: any) {
    const { step, index, previousSteps } = getSelectedStepDetailsById(query, selectedStepId)
    const _query = generateInitialQuery(query)

    const _step = Object.assign({}, step);
    (_step as any)[field] = value

    _query.steps.splice(index, 1, _step)
    return _query
}




